const messages = {
  'zh-CN': {
    nav: {
      home: '首页',
      logout: '退出',
      language: '语言',
      theme: '主题'
    },
    tags: {
      dashboard: '仪表盘',
      refresh: '刷新',
      close: '关闭',
      closeOthers: '关闭其他',
      closeAll: '关闭全部'
    },
    common: {
      light: '浅色',
      dark: '深色',
      chinese: '中文',
      english: 'English'
    }
  },
  en: {
    nav: {
      home: 'Home',
      logout: 'Sign out',
      language: 'Language',
      theme: 'Theme'
    },
    tags: {
      dashboard: 'Dashboard',
      refresh: 'Refresh',
      close: 'Close',
      closeOthers: 'Close Others',
      closeAll: 'Close All'
    },
    common: {
      light: 'Light',
      dark: 'Dark',
      chinese: '中文',
      english: 'English'
    }
  }
}

export function translate(lang, key) {
  const locale = messages[lang] || messages['zh-CN']
  return key.split('.').reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : null), locale) || key
}

export default messages



// WEBPACK FOOTER //
// ./src/lang/index.js